import type { SubTemplateProps } from './RowTemplateTypes'
import { useRowSurface } from './RowSurfaceContext'
import { useSubsStore } from '@/state/MsgTreeProvider'

// Neutral shared folder row — the one look for the favs/drafts/trash pages on
// every surface. Deliberately minimal: check control, title link, time, text
// snippet, and the child counts as PLAIN NUMBERS. Folder rows never open or
// load nested subs (the disclosure/load-more machinery is main-desk behavior),
// and drafts shows no counts at all: a draft's children are its co-moved
// drafts, so the numbers only mislead. The favorite control renders only on
// the favs page, where it means "remove from bookmarks".
// SKELETON: emits md-* structural classes only; visuals come from the
// surface's optional skin.folder tokens (Layer C, per-surface).
export function FolderRowTemplate({ display, controls }: SubTemplateProps) {
  const { skin } = useRowSurface()
  const { state } = useSubsStore()
  const mode = state.renderProjection.mode
  const folder = skin.folder ?? {}
  const counts = display.counts
  const showCounts = !display.access.isContentLocked && mode !== 'drafts' && (counts.answers > 0 || counts.submsges > 0)

  return (
    <div className={`md-folder-row ${folder.row ?? ''}`}>
      <div className={`md-folder-row__head ${folder.head ?? ''}`}>
        {controls.check}
        <span className={`md-folder-row__title ${folder.title ?? ''}`}>{controls.title}</span>
        {mode === 'favs' ? controls.favorite : null}
        <span className={`md-folder-row__time ${folder.time ?? ''}`}>{controls.time}</span>
      </div>
      <div className={`md-folder-row__text ${folder.text ?? ''}`}>{controls.text}</div>
      {showCounts ? (
        <div className={`md-folder-row__counts ${folder.counts ?? ''}`}>
          {counts.answers > 0 ? (
            <span className={`md-folder-row__count ${folder.count ?? ''}`}>answers({counts.answers})</span>
          ) : null}
          {counts.submsges > 0 ? (
            <span className={`md-folder-row__count ${folder.count ?? ''}`}>msges({counts.submsges})</span>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
